export const ADDRESS_BOOK_ENTRIES_FETCH_REQUESTED =
  'ADDRESS_BOOK_ENTRIES_FETCH_REQUESTED';
export const ADDRESS_BOOK_ENTRIES_FETCH_SUCCEEDED =
  'ADDRESS_BOOK_ENTRIES_FETCH_SUCCEEDED';
export const ADDRESS_BOOK_ENTRIES_FETCH_FAILED =
  'ADDRESS_BOOK_ENTRIES_FETCH_FAILED';
